module.exports = __webpack_public_path__ + "static/media/country_as.29856604.webp";